// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l5PH","fullView":"styles_fullView__1Pitb"};